import { Base_Url } from "../../BaseURL/BaseUrl";
import {
  getApiWithAuthorization,
  postApiWithAuthorization,
} from "../ApiMethods/ApiMethod";

const CountUrl = `${Base_Url}/Dashboard`;

export const GetUserDashboardCountModel = async (params) => {
  const res = await postApiWithAuthorization(
    `${CountUrl}/GetDashboardCountList`,
    params
  );
  return res;
};

export const GetUserActivityLogList = async (params) => {
  const res = await postApiWithAuthorization(
    `${Base_Url}/ActivityLog/GetActivityLogList`,
    params
  );
  return res;
};

export const GetPermissionListAPI = async (params) => {
  const res = await postApiWithAuthorization(
    `${Base_Url}/Login/GetMyPermission`,
    params
  );
  return res;
};
